module.exports = __webpack_public_path__ + "static/media/subICloud2.7cf25085.png";